import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  Backdrop,
  Box,
  Button,
  Divider,
  Menu,
  MenuItem,
  Modal,
  Popover,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import SnackbarComponent from "components/snackbar/SnackbarComponent";
import AccountChangePasswordSidebarComponent from "features/account/component/account-change-password-sidebar/AccountChangePasswordSidebarComponent";
import AccountEditSidebarComponent from "features/account/component/account-edit-sidebar/AccountEditSidebarComponent";
import AccountProfileSidebarComponent from "features/account/component/account-profile-sidebar/AccountProfileSidebarComponent";
import {
  checkUserNotification,
  getUserNotification,
  getUserProfile,
  readUserNotification,
} from "features/account/service/AccountProfileService";
import { logout } from "features/login/service/LoginService";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LayoutHeaderComponent.css";
import storage from "services/storage";
import AccountChangeLogoComponent from "features/account/component/account-change-logo/AccountChangeLogoComponent";
import { useSnackbar } from "components/snackbar/SnackbarContext";
import AccountActivityLog from "features/account/component/account-activity-log/AccountActivityLog";
import UserManagementList from "features/account/component/user-management/UserManagementList";
import UserManagementCreateAccount from "features/account/component/user-management/UserManagementCreateAccount";
import UserManagementEditAccount from "features/account/component/user-management/UserManagementEditAccount";
import { NotificationComponent } from "components/notifications/NotificationComponent";
import { useLayout } from "components/layout/LayoutComponentContext";

const LayoutHeaderComponent = ({ setRole }) => {
  const [isChangePasswordOpen, setChangePasswordOpen] = useState(false);
  const [isEditOpen, setEditOpen] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [openConfirmLogout, setOpenConfirmLogout] = useState(false);
  const [isChangeLogoOpen, setChangeLogoOpen] = useState(false);
  const [isActivityLogOpen, setActivityLogOpen] = useState(false);
  const [isUserManagementOpen, setUserManagementOpen] = useState(false);
  const [
    isUserManagementCreateAccountOpen,
    setUserManagementCreateAccountOpen,
  ] = useState(false);
  const [isUserManagementEditAccountOpen, setUserManagementEditAccountOpen] =
    useState(false);
  const [currentEditUserManagement, setCurrentEditUserManagement] =
    useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const [helpCentreAnchorEl, setHelpCentreAnchorEl] = useState(null);
  const [userNotification, setUserNotification] = useState(null);
  const [currentNotificationTab, setCurrentNotificationTab] =
    useState("client");
  const [hasNotification, setHasNotification] = useState(false);
  const { companyProfile } = useLayout();
  const { message, setMessage } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    getUserAPI();
    checkUserNotificationAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getNotificationAPI(currentNotificationTab);
  }, [currentNotificationTab]);

  const handleChangeTab = (_, newTab) => {
    setCurrentNotificationTab(newTab);
  };

  const getUserAPI = async () => {
    const response = await getUserProfile();
    if (Object.keys(response).length !== 0) {
      storage.setItem("effectCode", response?.data?.company?.code);
      storage.setItem("role", response?.data?.role);
      setRole(response?.data?.role);
      storage.setCompanyID(response?.data?.company_id);
      setUserProfile(response?.data);
    }
  };

  const getNotificationAPI = async (category) => {
    const response = await getUserNotification(category);
    if (Object.keys(response).length !== 0) {
      setUserNotification(response?.data);
    }
  };

  const checkUserNotificationAPI = async () => {
    const checkNotification = await checkUserNotification(storage.getItem("type"));
    if (checkNotification) {
      setHasNotification(true);
    } else {
      setHasNotification(false);
    }
  };

  const readNotificationAPI = async (notification_id) => {
    await readUserNotification(notification_id);
  };

  const goToMonitoringDashboard = () => navigate("/dashboard");

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUserClick = (event) => {
    event.preventDefault();
    if (Boolean(anchorEl)) {
      handleClose();
    } else {
      handleCloseNotification();
      handleCloseHelpCentre();
      setAnchorEl(event.currentTarget);
    }
  };

  const handleNotificationClick = async (event) => {
    event.preventDefault();
    if (notificationAnchorEl) {
      handleCloseNotification();
    } else {
      handleClose();
      handleCloseHelpCentre();
      setNotificationAnchorEl(event.currentTarget);
      await getNotificationAPI(currentNotificationTab);
    }
  };

  const handleCloseNotification = () => {
    setNotificationAnchorEl(null);
  };

  const handleHelpCentreClick = (event) => {
    event.preventDefault();
    if (helpCentreAnchorEl) {
      handleCloseHelpCentre();
    } else {
      handleCloseNotification();
      handleClose();
      setHelpCentreAnchorEl(event.currentTarget);
    }
  };

  const handleCloseHelpCentre = () => {
    setHelpCentreAnchorEl(null);
  };

  const handleProfile = () => {
    if (
      !isProfileOpen &&
      !isEditOpen &&
      !isChangePasswordOpen &&
      !isChangeLogoOpen
    ) {
      setProfileOpen(true);
    }
    handleClose();
  };

  const handleLogout = async () => {
    const response = await logout();

    storage.clear();
    navigate("/", { replace: true });
    handleClose();

    if (!response?.info) {
      setMessage({
        title: "Error",
        desc: response,
        type: "error",
      });
    }
  };

  const handleCloseConfirmLogoutModal = () => {
    setOpenConfirmLogout(false);
  };

  const TabPanel = ({ children, panel, panelName, ...other }) => {
    return (
      <div
        className='h-full'
        role='tabpanel'
        hidden={panel !== panelName}
        id={`tabpanel-${panelName}`}
        aria-labelledby={`tab-${panelName}`}
        {...other}
      >
        {panel === panelName && (
          <Box height='100%'>
            <Stack divider={<Divider />}>
              {Boolean(userNotification?.length) ? userNotification?.map((notification) => {
                return (
                  <NotificationComponent
                    notification={notification}
                    onReadNotification={async () => {
                      await readNotificationAPI(notification?.user_notification_id);
                      await checkUserNotificationAPI();
                    }}
                  />
                );
              }) : (
                <Stack className="mt-4" justifyContent='center' alignItems='center' height='100%' spacing={2}>
                  <img
                    alt='notification-empty-icon'
                    src='/images/empty-notification.svg'
                  />
                  <Typography fontWeight={500} fontSize={12}>No activity available</Typography>
                </Stack>
              )
              }
            </Stack>
          </Box>
        )}
      </div>
    );
  };

  return (
    <>
      <div className='layout-header shadow-lg'>
        <div className='header-logo-container'>
          <img
            alt='qaptive-logo'
            className='header-logo cursor-pointer'
            src='/images/logo/qaptive-logo.svg'
            onClick={goToMonitoringDashboard}
            height={40}
            width={165}
          />
        </div>

        <div className='header-title-container'>
          <div className='header-action gap-8'>
            <div className='p-1 cursor-pointer hover:bg-[#EEF1F8] rounded-[4px]'>
              <HelpOutlineIcon onClick={handleHelpCentreClick} />
            </div>
            {/* TODO: Modify Conditional Notification Icon when ready to implement in prod */}
            {process.env.REACT_APP_ENVIRONMENT === "staging" && (
              <div className='relative p-1 cursor-pointer hover:bg-[#EEF1F8] rounded-[4px]'>
                <NotificationsNoneIcon onClick={handleNotificationClick} />
                {hasNotification && (
                  <div className='absolute top-2 right-1.5 w-2 h-2 bg-red-500 rounded-full' />
                )}
              </div>
            )}
            <div
              className={`p-2 pr-[30px] rounded-md flex gap-[12px] items-center cursor-pointer hover:bg-[#EEF1F8] ${Boolean(anchorEl) ? "bg-[#EEF1F8]" : ""
                }`}
              onClick={handleUserClick}
            >
              {userProfile?.avatar_path ? (
                <img
                  alt='account-profile-icon'
                  className='h-8 w-8 rounded-full shrink-0 object-cover'
                  src={userProfile?.avatar_path}
                />
              ) : (
                <AccountCircleRoundedIcon
                  viewBox='2 2 20 20'
                  aria-label='account-profile-image-default'
                  className='p-0'
                  sx={{ height: "32px", width: "32px", color: "#ccc" }}
                />
              )}

              <span className='header-user-label'>
                {userProfile?.full_name}
              </span>
            </div>

            {isProfileOpen && (
              <AccountProfileSidebarComponent
                isProfileOpen={isProfileOpen}
                onChangePassword={() => {
                  setProfileOpen(false);
                  setChangePasswordOpen(true);
                }}
                onCloseProfile={() => setProfileOpen(false)}
                onEditProfile={() => {
                  setProfileOpen(false);
                  setEditOpen(true);
                }}
                onChangeLogo={() => {
                  setProfileOpen(false);
                  setChangeLogoOpen(true);
                }}
                onOpenActivityLog={() => {
                  setProfileOpen(false);
                  setActivityLogOpen(true);
                }}
                onOpenUserManagement={() => {
                  setProfileOpen(false);
                  setUserManagementOpen(true);
                }}
                userProfile={userProfile}
              />
            )}

            {isEditOpen && (
              <AccountEditSidebarComponent
                isOpen={isEditOpen}
                onBack={() => {
                  setEditOpen(false);
                  setProfileOpen(true);
                }}
                onClose={() => setEditOpen(false)}
                onSuccess={getUserAPI}
                user={userProfile}
              />
            )}

            {isChangePasswordOpen && (
              <AccountChangePasswordSidebarComponent
                isOpen={isChangePasswordOpen}
                onBack={() => {
                  setChangePasswordOpen(false);
                  setProfileOpen(true);
                }}
                onClose={() => {
                  setChangePasswordOpen(false);
                }}
                user={userProfile}
              />
            )}

            {isChangeLogoOpen && (
              <AccountChangeLogoComponent
                isOpen={isChangeLogoOpen}
                onBack={() => {
                  setChangeLogoOpen(false);
                  setProfileOpen(true);
                }}
                onClose={() => {
                  setChangeLogoOpen(false);
                }}
              />
            )}

            {isActivityLogOpen && (
              <AccountActivityLog
                isOpen={isActivityLogOpen}
                onBack={() => {
                  setActivityLogOpen(false);
                  setProfileOpen(true);
                }}
                onClose={() => {
                  setActivityLogOpen(false);
                }}
                user={userProfile}
              />
            )}

            {isUserManagementOpen && (
              <UserManagementList
                isOpen={isUserManagementOpen}
                onBack={() => {
                  setUserManagementOpen(false);
                  setProfileOpen(true);
                }}
                onClose={() => {
                  setUserManagementOpen(false);
                }}
                onOpenCreateAccount={() => {
                  setProfileOpen(false);
                  setUserManagementOpen(false);
                  setUserManagementCreateAccountOpen(true);
                }}
                onOpenEditAccount={(currentEditUser) => {
                  setProfileOpen(false);
                  setUserManagementOpen(false);
                  setUserManagementEditAccountOpen(true);
                  setCurrentEditUserManagement(currentEditUser);
                }}
              />
            )}

            {isUserManagementCreateAccountOpen && (
              <UserManagementCreateAccount
                isOpen={isUserManagementCreateAccountOpen}
                onBack={() => {
                  setUserManagementCreateAccountOpen(false);
                  setUserManagementOpen(true);
                }}
                onClose={() => {
                  setUserManagementCreateAccountOpen(false);
                }}
                user={userProfile}
              />
            )}

            {isUserManagementEditAccountOpen && (
              <UserManagementEditAccount
                isOpen={isUserManagementEditAccountOpen}
                onBack={() => {
                  setUserManagementEditAccountOpen(false);
                  setUserManagementOpen(true);
                }}
                onClose={() => {
                  setUserManagementEditAccountOpen(false);
                }}
                currentEditUser={currentEditUserManagement}
                user={userProfile}
              />
            )}
          </div>
        </div>

        {message.title && (
          <SnackbarComponent
            labelTitle={message.title}
            labelMessage={message.desc}
            type={message.type}
            duration={5000}
          />
        )}
      </div>
      <Backdrop
        open={Boolean(anchorEl || notificationAnchorEl || helpCentreAnchorEl)}
        sx={(theme) => ({
          background: "rgba(0, 0, 0, 0.25)",
          zIndex: theme.zIndex.drawer + 1,
        })}
      >
        <Menu
          className='header-user-menu mt-[10px]'
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          autoFocus={false}
        >
          <MenuItem className='gap-2' onClick={handleProfile}>
            <SettingsOutlinedIcon />
            <span className='font-semibold'>Account Settings</span>
          </MenuItem>

          <MenuItem
            className='gap-2'
            onClick={() => {
              handleClose();
              setOpenConfirmLogout(true);
            }}
          >
            <ExitToAppOutlinedIcon />
            <span className='font-semibold'>Logout</span>
          </MenuItem>
        </Menu>
        <Popover
          open={Boolean(notificationAnchorEl)}
          anchorEl={notificationAnchorEl}
          onClose={handleCloseNotification}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          className='mt-6 !shadow-none'
        >
          <Stack className='py-5 w-[512px]' spacing={1}>
            <Typography fontWeight={700} className='px-6'>
              Notifications
            </Typography>
            <Stack className='px-2 w-full' divider={<Divider />}>
              {companyProfile ? (
                Boolean(userNotification?.length) ? userNotification.map((notification) => {
                  return (
                    <NotificationComponent
                      notification={notification}
                      onReadNotification={async () => {
                        await readNotificationAPI(notification?.user_notification_id);
                        await checkUserNotificationAPI();
                      }}
                    />
                  );
                }) : (
                  <Stack className="mt-4" justifyContent='center' alignItems='center' height='100%' spacing={2}>
                    <img
                      alt='notification-empty-icon'
                      src='/images/empty-notification.svg'
                    />
                    <Typography fontWeight={500} fontSize={12}>No reports available</Typography>
                  </Stack>
                )
              ) : (
                <div className='w-full'>
                  <Tabs
                    indicatorColor='#000'
                    value={currentNotificationTab}
                    onChange={handleChangeTab}
                    variant='fullWidth'
                  >
                    <Tab
                      value='client'
                      label='Clients'
                      style={{ minWidth: "50%" }}
                    />
                    <Tab
                      value='admin'
                      label='Admins'
                      style={{ minWidth: "50%" }}
                    />
                  </Tabs>
                  <TabPanel panel={currentNotificationTab} panelName='client' />
                  <TabPanel panel={currentNotificationTab} panelName='admin' />
                </div>
              )}
            </Stack>
          </Stack>
        </Popover>
        <Popover
          open={Boolean(helpCentreAnchorEl)}
          anchorEl={helpCentreAnchorEl}
          onClose={handleCloseHelpCentre}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          className='mt-6 !shadow-none'
        >
          <Stack className='py-5 px-2' spacing={1}>
            <Stack
              direction='row'
              spacing={1}
              alignItems='center'
              className='min-w-[184px] px-4 py-2'
            >
              <WhatsAppIcon color='' />
              <a
                className='font-semibold text-xs'
                href='https://wa.me/628122022257'
                target='__blank'
              >
                CS WhatsApp
              </a>
            </Stack>
            <Stack
              direction='row'
              spacing={1}
              alignItems='center'
              className='min-w-[184px] px-4 py-2'
            >
              <MailOutlineRoundedIcon />
              <a
                className='font-semibold text-xs'
                href='mailto:helpdesk1@sinartama.co.id'
                target='_top'
              >
                CS E-mail
              </a>
            </Stack>
          </Stack>
        </Popover>
      </Backdrop>

      <Modal
        open={openConfirmLogout}
        onClose={() => handleCloseConfirmLogoutModal()}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 343,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            px: "40px",
            py: "32px",
          }}
        >
          <span className='font-semibold'>
            Are you sure you want to log out?
          </span>
          <div className='flex flex-row gap-4 justify-center mt-[20px]'>
            <Button variant='outlined' onClick={handleCloseConfirmLogoutModal}>
              Cancel
            </Button>
            <Button
              className='!bg-[#556FB5]'
              onClick={handleLogout}
              variant='contained'
            >
              Logout
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default LayoutHeaderComponent;
